import type { Vehicle } from '../types/vehicle'

export const stockVehicles: Vehicle[] = [
  {
    id: 'stk-01',
    marca: 'Ford',
    modelo: 'Fiesta Kinetic Titanium 1.6 S',
    anio: '2011',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/215ccfd7-5e9f-4111-9a9f-49e1e99c6412.jpg?v=1787178592',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/2117b0ea-4ce8-49c5-a8fa-eb6b60b53198.jpg?v=1787178635',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/12e0b507-2f58-4ce0-877e-3af087e744fd.jpg?v=1787178652',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/fd117ae7-5cc8-4250-be25-4323e12d7769.jpg?v=1787178659',
    ],
  },
  {
    id: 'stk-02',
    marca: 'Fiat',
    modelo: 'Uno Way',
    anio: '2011',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/eef39fd7-b1d0-4c8c-9860-e5be02d69a13.jpg?v=1787178694',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/60478427-4df1-4ae4-88ae-b1e2cb1d93d6.jpg?v=1787178683',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/70222279-b607-433e-9bea-285f8fa843ca.jpg?v=1787178704',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/ee0bd22f-7fb0-4a57-a7f3-1d3acfc3a416_1.jpg?v=1787178716',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/0d8ebaa9-9d98-45d4-9073-0242ac3b65fd.jpg?v=1787178734',
    ],
  },
  {
    id: 'stk-03',
    marca: 'Renault',
    modelo: 'Sandero Privilege 1.6',
    anio: '2014',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/89bddab5-55b9-4efe-85d7-152a3e2e22bf.jpg?v=1787178815',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/44f8bceb-ded4-4f68-9f21-8b147e3798d5.jpg?v=1787178768',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/9cfba1c2-220e-4d22-8036-94a305915d5c.jpg?v=1787178826',
    ],
  },
  {
    id: 'stk-04',
    marca: 'Toyota',
    modelo: 'Corolla XLI 1.8 MT',
    anio: '2015',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/f4cc66a2-95a6-4e14-8286-24641e187dfe.jpg?v=1787178853',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/4e52e8ab-2e62-4884-b1e8-5efc9183bbd8.jpg?v=1787178844',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/7e29c378-0e04-4b81-b4d4-333500aa3eb0.jpg?v=1787178857',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/eb03ef0e-a873-436e-9fea-fee7f93c849f.jpg?v=1787178862',
    ],
  },
  {
    id: 'stk-05',
    marca: 'Chevrolet',
    modelo: 'Corsa II 5 Ptas GL Pack GNC 1.4',
    anio: '2003',
    combustible: 'GNC',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/85eb1eee-4204-449e-a531-f7d62c664aa1.jpg?v=1787180034',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/508c1c4c-4ff0-486b-96ec-8450490d1bf4.jpg?v=1787180022',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/f66b479a-80cc-4807-bca5-41cf047dd1de.jpg?v=1787180029',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/6af42d56-d42b-4732-a0ec-6861d552da4a.jpg?v=1787180040',
    ],
  },
  {
    id: 'stk-06',
    marca: 'Chevrolet',
    modelo: 'Prisma Joy 4P 1.4 LS MT',
    anio: '2019',
    combustible: 'Nafta/GNC',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/7569ac47-cfd7-4a3a-b7c6-f0e7151c9f27.jpg?v=1787180052',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/48428191-c380-4de2-976a-3dbc0f24e0ab.jpg?v=1787180046',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/90183445-3fe2-4442-b6f1-644d453c7b84.jpg?v=1787180059',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/63f09d5e-ff85-4967-9588-d0ba9861229e.jpg?v=1787180064',
    ],
  },
  {
    id: 'stk-07',
    marca: 'Nissan',
    modelo: 'Versa 1.6',
    anio: '2017',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/399df78f-2ffa-47ec-881f-b9722acb3e07.jpg?v=1787180150',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/8a993596-d097-4f2f-bc93-7c5eb8bed769.jpg?v=1787180146',
    ],
  },
  {
    id: 'stk-08',
    marca: 'Peugeot',
    modelo: '408',
    anio: '2014',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/WhatsApp_Image_2026-08-19_at_19.44.47.jpg?v=1787179618',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/WhatsApp_Image_2026-08-19_at_19.44.50.jpg?v=1787179589',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/WhatsApp_Image_2026-08-19_at_19.44.48.jpg?v=1787179612',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/WhatsApp_Image_2026-08-19_at_19.44.45.jpg?v=1787179623',
    ],
  },
  {
    id: 'stk-09',
    marca: 'Renault',
    modelo: 'Fluence 1.6',
    anio: '2014',
    combustible: 'Nafta/GNC',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/efb5718a-1de9-4280-8419-2de108771b63.jpg?v=1787180734',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/1fb3f37f-157d-49c5-a0ed-62bc864befc7.jpg?v=1787180719',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/fc83519c-850c-4d6f-bc8e-6f6650627d07.jpg?v=1787180738',
    ],
  },
  {
    id: 'stk-10',
    marca: 'Volkswagen',
    modelo: 'Vento 2.0 TSI',
    anio: '2011',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_783770-MLA113861736232_072026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_813741-MLA115164320353_072026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_800975-MLA113861676782_072026-F.webp?v=1787181846',
    ],
  },
  {
    id: 'stk-11',
    marca: 'Honda',
    modelo: 'HR-V EX CVT',
    anio: '2017',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_661872-MLA113710927797_062026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_913797-MLA112250058888_062026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_951375-MLA112248489452_062026-F.webp?v=1787181847',
    ],
  },
  {
    id: 'stk-12',
    marca: 'Peugeot',
    modelo: '308 Allure 1.6N Nav',
    anio: '2013',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_927017-MLA112766998388_062026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_894084-MLA113960847093_062026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_978888-MLA112767266188_062026-F.webp?v=1787181848',
    ],
  },
  {
    id: 'stk-13',
    marca: 'Peugeot',
    modelo: '208 Active Tiptronic 1.6L AM23',
    anio: '2023',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_955057-MLA111921510694_062026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_853759-MLA111617688968_062026-F.webp?v=1787181847',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_736157-MLA111616091884_062026-F.webp?v=1787181846',
    ],
  },
  {
    id: 'stk-14',
    marca: 'Ford',
    modelo: 'Focus III 2.0 Se',
    anio: '2015',
    km: '85000',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_932681-MLA112597503202_062026-F.webp?v=1787238563',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_794397-MLA112261427606_062026-F.webp?v=1787238562',
    ],
  },
  {
    id: 'stk-15',
    marca: 'Ford',
    modelo: 'Focus III 1.6 S',
    anio: '2015',
    km: '127000',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_814361-MLA115444342323_082026-F.webp?v=1787238594',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_716894-MLA105115590669_012026-F.webp?v=1787238594',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_811328-MLA105114696795_012026-F.webp?v=1787238594',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_802529-MLA105114488315_012026-F.webp?v=1787238594',
    ],
  },
  {
    id: 'stk-16',
    marca: 'Volkswagen',
    modelo: 'Virtus 1.6 Comfortline',
    anio: '2018',
    km: '140000',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_690500-MLA98980473511_112025-F.webp?v=1787238594',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_931519-MLA98980473509_112025-F.webp?v=1787238594',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_658534-MLA98980423387_112025-F.webp?v=1787238595',
    ],
  },
  {
    id: 'stk-17',
    marca: 'Fiat',
    modelo: 'Strada 1.6 Adventure CD Pack Top',
    anio: '2015',
    km: '172000',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_849738-MLA113958463509_062026-F.webp?v=1787238603',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_971672-MLA113959797343_062026-F.webp?v=1787238603',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_856770-MLA113959383365_062026-F.webp?v=1787238603',
    ],
  },
  {
    id: 'stk-18',
    marca: 'Chevrolet',
    modelo: 'Cruze 1.8 LTZ',
    anio: '2013',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_735672-MLA112250030228_062026-F.webp?v=1787238602',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_853775-MLA113398334561_062026-F.webp?v=1787238596',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_754803-MLA113398334613_062026-F.webp?v=1787238595',
    ],
  },
  {
    id: 'stk-19',
    marca: 'Volkswagen',
    modelo: 'Gol Trend 1.6 Comfortline 101cv',
    anio: '2017',
    km: '71000',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_653607-MLA112249643142_062026-F.webp?v=1787238603',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_634770-MLA105690707263_012026-F.webp?v=1787238603',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_728545-MLA105113399380_012026-F.webp?v=1787238603',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_835017-MLA105691594491_012026-F.webp?v=1787238603',
    ],
  },
  {
    id: 'stk-20',
    marca: 'BMW',
    modelo: 'Serie 1 2.0 118i Active 136cv',
    anio: '2011',
    km: '189000',
    combustible: 'Nafta',
    estado: 'Disponible',
    fotos: [
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_739670-MLA115686941701_082026-F.webp?v=1787238603',
      'https://cdn.shopify.com/s/files/1/0993/9084/9330/files/D_NQ_NP_2X_635071-MLA114244660892_082026-F.webp?v=1787238603',
    ],
  },
]
